<template>
  <el-dialog 
    :modal-append-to-body="false"
    :title="openType === 'add' ? '新增轮播' : '编辑轮播'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="50%"
    custom-class="customModal">
    
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="name" class="formItemFill" label="名称">
            <el-input v-model="formValue.name" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="平台" prop="platform" class="formItemFill">
            <el-select v-model="formValue.platform" placeholder="请选择" size="small" style="width: 100%;">
              <el-option
                v-for="item in platform"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="事件类型" prop="event_type" class="formItemFill">
            <el-select v-model="formValue.event_type" placeholder="请选择" size="small" style="width: 100%;">
              <el-option
                v-for="item in event_type"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="event_value" class="formItemFill" label="事件值">
            <el-input v-model="formValue.event_value" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
            <vue-ueditor-wrap v-model="content" :config="myConfig" :readyOnly='true'></vue-ueditor-wrap>
            <div class="imgBox" v-html="imgContent"></div>
            <!-- <el-form-item prop="images_url" class="formItemFill upload" label="上传图片" style="text-align:left">
                <div v-if="displayMap" style="height: 5vw;position:absolute;top:40px;"><img :src="formValue.images_url" style="height:5vw;object-fill:contain" /></div>
                <el-upload
                ref="upload"
                :data="this.fileData"
                class="upload-demo"
                :file-list="fileList"
                :on-change="changeIMG"
                action="https://api.goodyiyao.cn/index.php/api/File_logic/upload"
                :on-remove="handleRemove"
                :auto-upload="false"
                :on-success="onSuccess"
                list-type="picture">
                <el-button size="small" type="primary" :class="hideUpload === true ? 'hide' : ''">点击上传</el-button>
                </el-upload>
                <el-button size="small" type="primary" :class="hideUpload === false ? 'hide' : ''" @click="submitIMG()" class="submit">提交</el-button>
            </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <el-form-item prop="bg_color" class="formItemFill bg_color" label="背景色" >
              <el-color-picker v-model="formValue.bg_color" style="width:100%;text-align:left;margin-top: 0.8vw"></el-color-picker>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item prop="sort" class="formItemFill" label="顺序" >
            <el-input type="number" v-model.number="formValue.sort" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="is_enable" class="formItemFill" label="是否启用" >
            <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
import VueUeditorWrap from 'vue-ueditor-wrap'

  export default {
    name: 'formRotationChart',
    components: { VueUeditorWrap  },
    data() {
      return {
        ue: '',
        content: '',
        myConfig: {
          toolbars:[['insertimage']],
      // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        //serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=slide&crossDomain: true',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ue/'
        },
        visible: false,
        openType: '',
        formValue: { },
        checkAll: false,
        event_type:'',
        platform: '',
        fileList: [],
        img_url:'',
        rules: {
          name: [{ required: true, message: '名称不能为空',trigger: 'blur'}],
          platform: [{ required: true,  message: '请选择平台', trigger: 'check' }],
          event_type: [{ required: true,  message: '请选择事件类型', trigger: 'check' }],
          event_value: [{ required: true, message: '事件值不能为空',trigger: 'blur'}],
          sort: [
            { required: true, message: '顺序不能为空'},
          ],
        }
      }
    },
    computed: {
      // eslint-disable-next-line vue/return-in-computed-property
      imgContent() {
        if(this.openType=='add'){
          if(this.content){
            let re = this.content.match(/<img.+?>/ig)
            if(re.length == 1) {
              return re[0]
            }
            return re[re.length-1]
          }
        }
        else{
          if(this.content){
            let re = this.content.match(/<img.+?>/ig)
            if(re.length == 1) {
              return re[0]
            }
            return re[re.length-2]
          }
        }
      }
    },
    methods: {
      async open(type, data, platform,event_type) {
        this.platform = platform
        this.event_type = event_type
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && data) {
          const result = JSON.parse(JSON.stringify(await WebsiteService.getListDetail(data.id)))
          this.content = '<img src='+result.images_url+'>'
          this.formValue = result
          this.formValue.images_url = ''
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: true,
          bg_color: "#fff",
          sort: 50,
          images_url: ''
        };
      },
      async submit() {
          const result = await this.$refs.form.validate();
          if(result) {
              this.formValue.images_url = this.imgContent.match('(?<=src=").[^"]*')[0].split('api.goodyiyao.cn/')[1]
              this.formValue.is_enable = this.formValue.is_enable ? 1 :0
              await WebsiteService.submitRotationChart(this.formValue);
              this.$emit('submitSuccess')
              this.close();
          }
      },
      // handleRemove(file, fileList) {
      //   if(this.openType === "edit"){
      //     this.displayMap = true
      //   }
      //   this.hideUpload = fileList.length >= this.limitCount
      // },
      // handlePreview(file) {
      //   console.log(file);
      // },
      // beforeUpload(file) {
      // },
      // changeIMG(file,fileList) {
      //   if(this.openType === "edit"){
      //     this.displayMap = false
      //   }
      //   this.hideUpload = fileList.length >= this.limitCount
      //   this.fileData.upfile = file.raw
      // },
      // submitIMG() {
      //   this.$nextTick(() => {
      //       this.$refs.upload.submit()
      //   })
      // },
      // onSuccess(res) {
      //   this.formValue.images_url = res.sub_path
      // },
      close() {
        this.visible = false;
        this.formValue = {};
        this.content = ''
      }
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>

<style lang="scss">
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
  .rotationChart{
    .el-dialog__wrapper{
      .upload.formItemFill{
        height: 8vw;
        position: relative;
        .el-upload-list__item{
          margin-top: 0;
        }
        .el-button{
          position: absolute;
          top: 0px;
          left: 120px;
        }
      }
      .bg_color.formItemFill{
        height: 8vw;
        .el-color-picker__trigger{
          width: 100%;
          height: 93px;
          margin-top: -3px;
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
  .imgBox{
    text-align: left;
    border: 1px solid #e6e6e6;
    height: 6.2vw;
    img{
      height: 6.2vw;
    }
  }
</style>